import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useXFetch } from '~/shared/utils/useXFetch';
import { toaster } from '~/shared/utils/toaster';

interface RemoveExceptionParams {
  volumeId: string;
  ruleId: string;
}

export function useRemoveException() {
  const api = useXFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ volumeId }: RemoveExceptionParams) => {
      const response = await api(`/api/v1/volumes/${volumeId}/autoscaling/rules/exclusions`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    },
    onSuccess: (_, variables) => {
      // Invalidate queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['autoscaleRules'] });
      queryClient.invalidateQueries({ queryKey: ['autoscaleRuleDetails', variables.ruleId] });
      queryClient.invalidateQueries({ queryKey: ['ruleDryRun'] });

      toaster({
        variant: 'success',
        title: 'Rule behavior restored',
        message: `Exception for ${variables.volumeId} has been cleared`,
      });
    },
    onError: (error) => {
      console.error('Failed to remove exception:', error);
      toaster({
        variant: 'error',
        title: 'Error',
        message: 'Failed to remove exception. Please try again.',
      });
    },
  });
}
